import { NextPaymentAction } from "@merchant_api/models/next-payment-action";

export class NextPaymentActionsState {
  loading = false;
  error = null;
  record: Array<NextPaymentAction> = [];
}
